import { injectable } from 'inversify';
import { SearchState } from '../../../models';
import { GettersClass } from '../../store.interfaces';
import { SEARCH_GETTERS_KEYS } from '../search.const';

@injectable()
export class InfiniteScrollEnabledGetter implements GettersClass<SearchState> {
  getters = {
    [SEARCH_GETTERS_KEYS.infiniteScrollEnabled]: (state: SearchState, getters: any): boolean => {
      return !state.loading && getters[SEARCH_GETTERS_KEYS.hasMoreResults];
    }
  };

}
